import { render, staticRenderFns } from "./addPurchaseApplyList.vue?vue&type=template&id=e5c0d5d8&scoped=true"
import script from "./addPurchaseApplyList.vue?vue&type=script&lang=js"
export * from "./addPurchaseApplyList.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseApplyList.vue?vue&type=style&index=0&id=e5c0d5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c0d5d8",
  null
  
)

export default component.exports